var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.loading
        ? _c(
            "a",
            {
              staticClass: "btn-link text-center font-weight-bold",
              on: { click: _vm.submit }
            },
            [_vm._v("Cancel subscription")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c("pulse-loader", {
            attrs: { loading: true, color: "#143642", size: "10px" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.errors && !Array.isArray(_vm.errors)
        ? _c("div", { staticClass: "alert alert-error mb-2" }, [
            _vm._v(_vm._s(_vm.errors))
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-173a299d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-173a299d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/settings/CancelSubScription.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-173a299d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/settings/CancelSubScription.vue
// module chunks = 0 1